import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNotEmptyOrUndefined'
})
export class IsNotEmptyOrUndefinedPipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        if (String(value).trim() === '' || value === undefined || value === null) {
            return false;
        }

        return true;
    }
}
